import React from 'react';
import { Mail, Linkedin } from 'lucide-react';
import { buildContactMailto } from '../../utils/mailto';

const LINKEDIN_URL = 'https://www.linkedin.com/in/pauasensio/';
const LINKTREE_URL = 'https://linktr.ee/PauAsensio';

const CTASection = ({ t, language }) => (
  <section id="contacto" className="py-16 bg-gradient-to-r from-blue-900 to-blue-700 curtain-section">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">{t.cta.title}</h2>
      <p className="text-xl text-blue-100 mb-4 leading-relaxed">{t.cta.description}</p>
      <p className="text-lg text-blue-200 mb-8">{t.cta.additionalInfo}</p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <a
          href={buildContactMailto(language)}
          target="_blank"
          rel="noopener noreferrer"
          className="bg-white text-blue-900 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-50 transition-all transform hover:scale-105 inline-flex items-center gap-2 shadow-lg"
          data-testid="cta-email-btn"
        >
          <Mail className="w-5 h-5" />
          {t.cta.ctaEmail}
        </a>
        <a
          href={LINKEDIN_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-blue-900 transition-all inline-flex items-center gap-2"
          data-testid="cta-linkedin-btn"
        >
          <Linkedin className="w-5 h-5" />
          {t.cta.ctaLinkedIn}
        </a>
        <a
          href={LINKTREE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-blue-900 transition-all inline-flex items-center gap-2"
          data-testid="cta-linktree-btn"
        >
          {t.cta.ctaLinktree}
        </a>
      </div>
    </div>
  </section>
);

export default CTASection;
